<template>
<tr class="isInRcpAvg" :data-id="country.country_id">
    <td v-if="country.country_name == 'United States'" class="country_name"><a :href="landing_page_url_usa+query_parameters" :target="landing_page_target" v-html="country.country_name"></a></td>
    <td v-else class="country_name" v-html="country.country_name"></td>
    <!--<td class="deaths_previous_day" v-if="wide" v-html="number_format_wrapper_plus(country.deaths_previous_day)"></td>-->
    <td v-html="number_format_wrapper(country.deaths_pm)"></td>
    <td v-if="wide" >-</td><!-- Total Case Fatality Rate -->
    <td v-if="!wide && !isIframe" >-</td><!--Total Case Fatality Rate -->
    <td v-if="!wide && isIframe" v-html="number_format_wrapper_plus(country.new_deaths)"></td>
    <td v-html="number_format_wrapper_total(country.confirmed)"></td>
    <td v-if="!wide" class="deaths_p_cases above_phone_portrait" v-html="number_format(country.deaths_p_cases, 2)+'%'"></td>
    <td v-if="wide" v-html="number_format(country.deaths_p_cases, 2)+'%'"></td>
    <!--<td class="actual_fatality_rate above_phone_portrait">-</td>-->
    <!--<td v-html="number_format_wrapper_plus(country.new_deaths)"></td>-->
    <td v-if="wide" class="above_phone_portrait estimated_cases">-</td><!-- Total Case Fatality Rate -->
    <td v-html="number_format_wrapper_total(country.tests)"></td>
    <td v-html="number_format_wrapper(country.tests_pm)"></td>
    <!--<td class="critical" v-html="number_format_wrapper_total(country.critical)"></td>-->
    <!--<td v-if="wide" v-html="number_format_wrapper(country.critical_pm)"></td>-->
    <!--<td v-if="!wide" class="estimated_cases above_phone_portrait">-</td>-->
    <td v-if="wide" v-html="number_format_wrapper(country.confirmed_pm)"></td>
    <!--<td v-html="number_format_wrapper_total(country.h1n1)"></td>-->
    <td v-if="!wide" class="deaths_p_cases phone_portrait" v-html="number_format(country.deaths_p_cases, 2)+'%'"></td>
    <td v-if="wide" v-html="number_format_wrapper_plus(country.new_deaths)"></td>
    <td class="deaths" v-html="number_format_wrapper_total(country.deaths)"></td>
    <!--<td v-if="!wide" class="influenza_deaths_v2 above_phone_portrait" v-html="number_format_wrapper_total(country.influenza_deaths_v2)"></td>
    <td v-if="wide" class="influenza_deaths_v2" v-html="number_format_wrapper_total(country.influenza_deaths_v2)"></td>-->
</tr>
</template>

<script>

import CovidMixin from './CovidMixin.js';

export default {
    name: 'country-row',
    mixins: [
        CovidMixin,
    ],
    props: {
        country: {
            type: Object,
            default: {},
        },
        wide: {
            type: Boolean,
            default: false,
        },
        isIframe: {
            type: Boolean,
            default: false,
        },
    },
    data : function() {
        return {
            landing_page_url : '/coronavirus/',
            landing_page_url_usa : '/coronavirus/country/united-states/',
        }
    },
    created : function() {
        
    },
    computed: {

        landing_page_target: function(){

            if(this.isIframe){
                return '_top';
            }

            return '_self';
        },

        query_parameters: function(){

            if(this.isIframe){
                return '?'+this.get_partners_utm_string();
            }
    
            return '';
        },

      },
    methods : {
        
    },
}
</script>